import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const connectedUserService = {
  async getAllAsync(params) {
    const response = await apiClient.get(endPoints.connectedUser.getAll, {
      params,
    });
    return response.data;
  },

  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.connectedUser.getAllSearch, {
      params,
      signal,
    });
    return response.data;
  },
};
